export default __webpack_public_path__ + "static/media/informationtech.ea89a339.png";